import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'reverseArray',
    standalone: false
})
export class ReverseArrayPipe implements PipeTransform {

  transform(value:Array<any>) {
    return value.slice().reverse();
  }

}
